export default {
  CATEGORY_DATA: [
    {
      title: "Lab Test Booking",
      id: 1,
      type: "labtest",
    },
    {
      title: "Consultations",
      id: 2,
      type: "consultations",
    },
  ],
  ORDER_HISTORY_DATA: [
    {
      id: 1,
      title: "CBC lab test booking",
      status: "Completed",
      bookedFor: "12/04/2024 (9:00am - 10:00am)",
      amount: 1500,
      amountPaidDate: "10/04/2024 at 1:00pm",
      type: "labTest",
      reportUrl: "hello",
      subType: "labTest",
    },
    {
      id: 2,
      title: "CBC lab test booking",
      status: "Upcoming",
      bookedFor: "12/04/2024 (9:00am - 10:00am)",
      amount: 1500,
      amountPaidDate: "10/04/2024 at 1:00pm",
      type: "labTest",
      subType: "labTest",
    },
    {
      id: 3,
      title: "CBC lab test booking",
      status: "Refund In Progress",
      bookedFor: "12/04/2024 (9:00am - 10:00am)",
      amount: 1500,
      amountPaidDate: "10/04/2024 at 1:00pm",
      type: "labTest",
      subType: "labTest",
    },
    {
      id: 4,
      title: "Nutritionist consultation",
      amount: 1500,
      amountPaidDate: "10/04/2024 at 1:00pm",
      type: "consultations",
      subType: "nutritionist",
    },
    {
      id: 5,
      title: "Psychologist consultation",
      amount: 1500,
      amountPaidDate: "10/04/2024 at 1:00pm",
      type: "consultations",
      subType: "psychologist",
    },
  ],
  RESCHEDULE_LAB_TEST: {
    title:
      "Please select the option that describes why you want to reschedule this test",
    options: [
      {
        id: 1,
        option: "Not available on selected time",
      },
      {
        id: 2,
        option: "Booked a different time slot",
      },
      {
        id: 3,
        option: "Family emergency",
      },
      {
        id: 4,
        option: "Other",
      },
    ],
  },
  CANCEL_LAB_TEST: {
    title:
      "Please select the option that describes why you want to cancel this test",
    options: [
      {
        id: 1,
        option: "Found better deal elsewhere",
      },
      {
        id: 2,
        option: "Test not required",
      },
      {
        id: 3,
        option: "Order placed by mistake",
      },
      {
        id: 4,
        option: "Other",
      },
    ],
  },
  ORDER_STATUS: {
    PENDING: "Pending",
    COMPLETED: "Completed",
    BOOKED: "Booked",
    CANCELLED: "Cancelled",
    RESCHEDULED: "Rescheduled",
    UPCOMING: "Upcoming",
  },
  REFUND_STATUS: {
    COMPLETED: "Completed",
    FAILED: "Failed",
    IN_PROGRESS: "In progress",
  },
  CUSTOME_STATUS: {
    REFUND_COMPLETED: "Refund Completed",
    REFUND_FAILED: "Refund Failed",
    REFUND_IN_PROGRESS: "Refund In Progress",
  },
  VENDOR_FLG: "redcliff",
  AMOUNT_REFUNDED: "Amount refunded",
  AMOUNT_PAID: "Amount paid",
  FREE: "Free",
  DEMO: "Demo",
};
